import React from "react";
import "./App.css";
import Header from "./components/header/Header";
import Nav from "./components/nav/Nav";
import About from "./components/about/About";
import Experience from "./components/experiences/experience";
import Services from "./components/services/Services";
import Portfolio from "./components/portfolio/Portfolio";

import Contact from "./components/contacts/Contact";
import Footer from "./components/footer/Footer";

function App() {
  return (
    <>
      <Header />
      <Nav />
      <About />
      <Experience />
      <Services />
      <Portfolio />

      <Contact />
      <Footer />
    </>
  );
}

export default App;
